<span class="date">{{ transaction.transactionDate | date: 'shortDate' }}</span>
<span>-</span>
<span class="wording">{{ transaction.wording }}</span>
<span class="amount" [class.accent]="transaction.amount > 0">{{ transaction.amount | number: '1.2-2' }}</span>
